const formatPhone10 = (value) => {
    if (value !== undefined) {
        let val = value.replace(/\D/g, "");
        let newVal = "";
        if (val.length > 0 && val.length < 14) {
            newVal += "(";
        }
        if (val.length > 3 && val.length < 7) {
            newVal += `${val.substr(0, 3)}) `;
            val = val.substr(3);
        } else if (val.length > 6 && val.length < 13) {
            newVal += `${val.substr(0, 3)}) `;
            newVal += `${val.substr(3, 3)}-`;
            val = val.substr(6);
        } else if (val.length > 9) {
            value = val;
        }
        if (newVal.length > 13) {
            newVal = newVal.slice(0, 13);
        }
        newVal += val;
        return newVal;
    }
    return "";
};

export default formatPhone10;
